import { useResidentContext } from "app/features/residents/provider/ResidentProvider";
import { FormEnums } from "app/services/api/types/forms/enums/FormEnums";
import { AssessmentReportFillTemplate } from "../../../features/reporting/templates/AssessmentReportFillTemplate";

export function AddBarthelScoreReport() {
  const { resident } = useResidentContext();

  const backPath = resident?.id
    ? `/residents/${resident.id}/barthel-score`
    : undefined;

  return (
    <AssessmentReportFillTemplate
      tag={FormEnums.BARTHEL_SCORE}
      backPath={backPath}
    />
  );
}
